import { ReactNode, useState } from "react";
import { Segment, SidebarPushable, SidebarPusher } from "semantic-ui-react";

import { MenuItem, MenuView, NavBar } from "components";
import { SessionManager } from "components/SessionManager";
import { NavActionsProvider } from "hooks";
import "layouts/PrivateRouteLayout/PrivateRouteLayout.scss";
import { PATHS } from "router/paths";

type PrivateRouteLayoutProps = {
  children: ReactNode;
};

export const PrivateRouteLayout = ({ children }: PrivateRouteLayoutProps) => {
  const [showSidebarMenu, setSidebarMenu] = useState(false);

  const showSidebar = () => setSidebarMenu(true);
  const hideSidebar = () => setSidebarMenu(false);

  return (
    <div className="main-container">
      <SessionManager />
      <SidebarPushable as={Segment} className="main-container-pushable">
        <MenuView isSideBarOpen={showSidebarMenu} hideSidebar={hideSidebar}>
          <MenuItem title="Upload Recalls" icon="upload" link={PATHS.UPLOAD} resource="recalls-upload-page" activity="browse" />
          <MenuItem title="Generate Recall Tokens" icon="registered" link={PATHS.GENERATE_RECALL_TOKENS} resource="api-keys-page" activity="browse" />
          <MenuItem title="Users" icon="users" link={PATHS.USERS} resource="users-page" activity="browse" />
          <MenuItem title="Recalls" icon="circle r" link={PATHS.DASHBOARD} resource="recalls-overview-page" activity="browse" />
        </MenuView>

        <SidebarPusher dimmed={showSidebarMenu} className="main-container-pusher-dimmed">
          <Segment basic className="main-container-segment">
            <NavActionsProvider>
              <NavBar openSidebar={showSidebar} />
              <div id="containerId" className="content-container">
                {children}
              </div>
            </NavActionsProvider>
          </Segment>
        </SidebarPusher>
      </SidebarPushable>
    </div>
  );
};
